import { hotelSubtitle } from './hotelUtils'

export default function HotelCard({ hotel, selected, onSelect }) {
  const place = hotelSubtitle(hotel)
  return (
    <button
      type="button"
      className={`hotelCard ${selected ? 'isSelected' : ''}`}
      onClick={() => onSelect?.(hotel)}
    >
      <div className={`hotelCardAccent credit-${hotel.inEdit && hotel.selectBrand ? 'both' : hotel.inEdit ? 'edit' : 'select'}`} />
      <div className="hotelCardBody">
        <h3>{hotel.name}</h3>
        {place ? <p className="hotelCardPlace">{place}</p> : null}
        <div className="hotelTags">
          {hotel.inEdit ? <span className="hotelTag edit">The Edit</span> : null}
          {hotel.selectBrand ? <span className="hotelTag select">Select Brand</span> : null}
          {hotel.brand && hotel.brand !== 'Other' ? <span className="hotelTag brand">{hotel.brand}</span> : null}
        </div>
        {hotel.onPropertyCredit ? <p className="hotelCardCredit">{hotel.onPropertyCredit}</p> : null}
        {hotel.priceCalendarUrl ? (
          <a
            className="hotelCardLink"
            href={hotel.priceCalendarUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            Google price calendar
          </a>
        ) : null}
      </div>
    </button>
  )
}
